const PUBLIC_LAYOUT = 'publicLayout';
const EXTERNAL_LAYOUT = 'externalLayout';
const NOT_FOUND_LAYOUT = 'notFoundLayout';
const LP_MARCH_26_LAYOUT = 'lpMarch26Layout';

export const LAYOUTS = {
  PUBLIC_LAYOUT,
  EXTERNAL_LAYOUT,
  NOT_FOUND_LAYOUT,
  LP_MARCH_26_LAYOUT,
};
